import { DocumentLayoutInfo } from "../documents/layout-info";

export class SaleLayoutInfo extends DocumentLayoutInfo{
	public ContactGroupID:number = 1;

	public constructor(data:any){
		super(data);
		this.ContactGroupID = data.ContactGroupID;
	}
}